module.exports = __webpack_public_path__ + "static/media/SearchIcon.e17d82c4.svg";